<template>
  <div class="mb-1">
      <div class="vx-row">
		<!--Clientt-->
        <div class="vx-col px-1 mb-2" v-if="activeUser.role == 1">
          <vs-select
            v-model="filterFields.society_id"
            class="w-full select-large"
            placeholder="Client"
            autocomplete
          >
            <vs-select-item
            v-if="activeUser.role == 1"
            value=""
            text="Client"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in userSocietiesList"
            class="w-full"
            />
          </vs-select>
        </div>
			<!--Numero du Contract-->
		<div class="vx-col px-1 mb-2">
           <vs-input class="inputx" placeholder="N° de contrat" v-model="filterFields.id" />
        </div>
			<!--Prestation-->
		<div class="vx-col px-1 mb-2" v-if="activeUser.role == 1">
          <vs-select
            v-model="filterFields.delivery_name"
            class="w-full select-large"
            placeholder="Type de prestation"
            autocomplete
          >
            <vs-select-item
            value=""
            text="Type de prestation"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.name"
            :text="item.name"
            v-for="(item, index) in prestationOption"
            class="w-full"
            />
          </vs-select>
        </div>
		<!--Prestation-->
		<div class="vx-col px-1 mb-2">
          <vs-select
            v-model="filterFields.type"
            class="w-full select-large"
            placeholder="Type"
            autocomplete
          >
            <vs-select-item
            value=""
            text="Type"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.id+1"
            :text="item.name"
            v-for="(item, index) in typeOption"
            class="w-full"
            />
          </vs-select>
        </div>
	<!--Status-->
		<div class="vx-col px-1 mb-2">
          <vs-select
            autocomplete
			multiple
            v-model="filterFields.status"
            class="w-full select-large"
            placeholder="Statut de la prestation"
          >
            <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in missionStatusOption"
            class="w-full"
            />
          </vs-select>
        </div>
	<!--Lien-->
	<div class="vx-col px-1 mb-2">
           <vs-input class="inputx" placeholder="Lien" v-model="filterFields.landing_page" />
        </div>
		<!--Anchor-->
		<div class="vx-col px-1 mb-2">
          <vs-select
            autocomplete
            v-model="filterFields.anchor_type"
            class="w-full select-large"
            placeholder="Type d'ancre"
          >
		    <vs-select-item
            value = ""
            text="Type d'ancre"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.value+1"
            :text="item.text"
            v-for="(item, index) in anchorOption"
            class="w-full"
            />
          </vs-select>
        </div>
		 <!--Type de lien-->
		<div class="vx-col px-1 mb-2">
          <vs-select
            autocomplete
            v-model="filterFields.link_type"
            class="w-full select-large"
            placeholder="Type de Lien"
          >
		    <vs-select-item
            value = ""
            text="Type de Lien"
            class="w-full"
            />
            <vs-select-item
            :key="index"
            :value="item.value+1"
            :text="item.text"
            v-for="(item, index) in linkOption"
            class="w-full"
            />
          </vs-select>
        </div>
		<!--Link Status-->
		<div class="vx-col px-1 mb-2">
          <vs-select
            autocomplete
            v-model="filterFields.link_status"
            class="w-full select-large"
            placeholder="Lien Statut"
			multiple

          >
		    <vs-select-item
				value = ""
				text="Lien Statut"
				class="w-full"
            />
            <vs-select-item
				:key="index"
				:value="item.id+1"
				:text="item.name"
				v-for="(item, index) in link_status_option"
				class="w-full"
            />
          </vs-select>
        </div>
		<div class="vx-col mb-2 px-1">
        <!-- DATE -->
        <vx-input-group class="w-full bottom">
		   <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span class="flex"
                  ><vs-icon icon="calendar_today" size="small"></vs-icon
                ></span>
              </div>
            </template>
          <flat-pickr
            class="w-full"
            v-model="filterFields.start_date"
            placeholder="Période"
            :config="configDatePicker"
            @keydown.native.delete.capture.stop.prevent
          />
        </vx-input-group>
        <!-- /DATE -->
        </div>
		<vx-tooltip text="Effacer les filtres" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button class ="ml-2" style="border: 0px;" type="line" @click="clearAll()" color="danger" icon="clear"></vs-button>
			</vx-tooltip>
      </div>
	    <div class="vx-row mt-2" v-if="listLength > 0">
        <div class="vx-col">
          <strong>Nombre de résultats : {{ listLength }}</strong>
        </div>
      </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";
export default {
	name: "GestionNetLinkingFilter",
	components: {
		flatPickr,
	},
	mixins: [dbFieldConvertorMixin],

	props: {
		listLength: Number,
		refreshKey: Number,
		userSocietiesOptions: Array,
		optionList: Object
	},
	data() {

		return {
			// Filter OBJECT
			filterFields: {
				filterType: "GESTION_NETLINKING_FILTER",
				society_id: "",
				id: "",
				type: "",
				thematiqueFilter: "",
				commercial_id: "",
				manager_id: "",
				status: "",
				delivery_name: "",
				total_max_budget_netlink: "",
				total_spent_budget_netlink: "",
				landing_page: "",
				anchor_type: "",
				link_type: "",
				link_status: "",
				start_date: new Date().toISOString().substring(0, 7).split("-").reverse().join("/"),
				end_date: ""
			},
			prestationOption: [],
			missionStatusOption: [],
			typeOption: [
				{"name": "One Shot", "id": 0},
				{"name": "Mensuel", "id": 1},

			],
			link_status_option: [
				{"name": "Actif", "id": 0},
				{"name": "A Valider", "id": 1},
				{"name": "Refusé", "id": 2},
				{"name": "Terminé", "id": 3},
				{"name": "En\u00a0cours\u00a0de\u00a0rédaction", "id": 4},
				{"name": "Annulé", "id": 5},
			],
			netlinkStatus: this.$props.optionList.netlinkStatus,
			anchorOption: this.$props.optionList.anchorTypes,
			linkOption: this.$props.optionList.linkTypes,
			dateOption: this.$props.optionList.dateOption,
			userSocietiesList: this.$props.userSocietiesOptions,
			configDatePicker: "",

		};
	},
	created() {
		this.getPrestationOption();
		this.missionStatusOption = this.getContractStatusList();
		this.configDatePicker= this.dateOption.configDatePicker;

		//assigning for refresh search
	},
	updated() {
		this.sendFilterReq();
	},
	computed:
	{
		listResult: () => {
			return store.state.contracts_contracts_users;
		},
 		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		"filterFields.start_date": {
			deep: true,
			handler(data) {
				this.filterFields.end_date = data;
				this.sendFilterReq();
			}
		},
	},
	methods: {
		clearAll(){
			this.filterFields = this.cleanField();
			this.sendFilterReq();
		},
		sendFilterReq(){
			store.dispatch("setFilterFields", this.filterFields);
			this.$emit("gestionFilterReq");
		},
		getPrestationOption(){
			this.$http.get("product/category/all",)
				.then((categories) => {
					this.prestationOption = categories.data;
				})
				.catch(err => {
					this.prestationOption = [];
				});
			//console.log(this.prestationOption);
		},
		cleanField(){
			return {
				filterType: "GESTION_NETLINKING_FILTER",
				society_id: "",
				id: "",
				type: "",
				thematiqueFilter: "",
				commercial_id: "",
				manager_id: "",
				status: "",
				delivery_name: "",
				total_max_budget_netlink: "",
				total_spent_budget_netlink: "",
				landing_page: "",
				anchor_type: "",
				link_type: "",
				link_status: "",
				start_date: new Date().toISOString().substring(0, 7).split("-").reverse().join("/"),
				end_date: ""
			};
		}

	}
};
</script>
<style lang="scss">
.table-filter{
	.con-tablex.vs-table--content{
		.vs-con-tbody.vs-table--tbody > table{
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead{
				display: none;
			}
			tr{
				.td-check{
					width: 40px;
				}
				td{
					border: none;
				}
			}
			.tr-expand > td > div{
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table{
				display: none;
			}
		}
		.not-data-table.vs-table--not-data{
			display: none;
		}
	}
}
</style>